<div class="col-12 border-0 animated position-relative">
    <div class="product-container">
        <a>
            <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" class="thumb-img"
                (error)="handleImageError($event)">
        </a>
        <div class="product-container__info">
            <header class="product-container__header">
                <h4>
                    {{ product()?.name }}
                </h4>

            </header>


            <div class="hstack">
                <div class="w-50">
                    @if (frequency() || productSubscriptionInfo()) {
                    <p class="card-text pt-0 mb-0">
                        Frequency: <b><i>{{ frequency() || productSubscriptionInfo()?.frequencyName }}</i></b>
                    </p>
                    }
                    @if (!isSubscriptionSkipped()) {
                    <p class="card-text pt-0 my-1">
                        Delivery: <b><i>{{ formattedDeliveryDate() }}</i></b>
                    </p>
                    }
                </div>
                @if(!isSubscriptionSkipped()) {
                <div class="w-50 text-end price-container">
                    <!-- Total Amount -->
                    <b>
                        {{product().quantity}} x {{ subTotalAmount() | currency }}
                    </b>
                </div>
                }
            </div>

        </div>
    </div>

</div>

@if(isSubscriptionSkipped()) {
<div class="d-flex flex-column align-items-center mt-5 animated fadeInUp skipped-product-container">

    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#007893">
        <path
            d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z" />
    </svg>

    <span class="h3-semibold text-center text-secondary my-3">
        You've skipped this product!
    </span>

    <span class="h5-semibold text-center text-black my-3">
        This product is not in your current order because you chose to skip it for
        <b><i>-{{productSubscriptionInfo()?.skipDate}}-</i></b>.
        You can add it back by clicking <b><i>'Unskip Product'</i></b> button.
    </span>

    <button type="button" class="btn btn-primary my-3" (click)="openModalUnskipProduct()">
        Unskip Product
    </button>

</div>
}